"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReorderSportsDto = instanceOfReorderSportsDto;
exports.ReorderSportsDtoFromJSON = ReorderSportsDtoFromJSON;
exports.ReorderSportsDtoFromJSONTyped = ReorderSportsDtoFromJSONTyped;
exports.ReorderSportsDtoToJSON = ReorderSportsDtoToJSON;
exports.ReorderSportsDtoToJSONTyped = ReorderSportsDtoToJSONTyped;
/**
 * Check if a given object implements the ReorderSportsDto interface.
 */
function instanceOfReorderSportsDto(value) {
    if (!('sportCodes' in value) || value['sportCodes'] === undefined)
        return false;
    return true;
}
function ReorderSportsDtoFromJSON(json) {
    return ReorderSportsDtoFromJSONTyped(json, false);
}
function ReorderSportsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sportCodes': json['sportCodes'],
    };
}
function ReorderSportsDtoToJSON(json) {
    return ReorderSportsDtoToJSONTyped(json, false);
}
function ReorderSportsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sportCodes': value['sportCodes'],
    };
}
